import { render, staticRenderFns } from "./servicecode.vue?vue&type=template&id=1e3895fb&"
import script from "./servicecode.vue?vue&type=script&lang=js&"
export * from "./servicecode.vue?vue&type=script&lang=js&"
import style0 from "./servicecode.vue?vue&type=style&index=0&id=1e3895fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports